export enum VolunteeringStepsEnum {
    VolunteeringInterests = 'Volunteering interests',
    PersonalDetails = 'Update personal details',
}